import { Component, OnInit, Input, AfterViewInit, AfterContentInit, Inject, OnChanges, NgZone, HostListener, inject, Output, EventEmitter, ViewChild } from '@angular/core';

// ol imports
import Map from 'ol/Map';
import { MapService } from '../../services/map.service';
import { LayerService } from '../../services/layers/layer.service';
import { ViewService } from '../../services/view.service';
import { ControlService } from '../../services/control.service';
import { format } from 'ol/coordinate';
import { fromExtent as polygonFromExtent } from 'ol/geom/Polygon.js';
import { WmsLayerService } from '../../services/layers/wms-layer.service';
import { AppEventService, PermalinkService } from '../../services/permalink.service';
import { TranslateService } from '@ngx-translate/core';
import { FeatureService } from '../../services/feature.service';
import { BehaviorSubject, fromEvent, Observable, of, Subject } from 'rxjs';

import { TT_LIB_CONFIG } from '../../tt-lib.config.token';
import { AppConfig } from '../../interfaces/app-config';
import { ElementRef } from '@angular/core';
import { debounceTime, filter, take } from 'rxjs/operators';

// import ResizeObserver from 'resize-observer-polyfill';
import { ActivatedRoute, Router } from '@angular/router';
import { Layer } from '@tt-lib/models/layer';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { App, AppState } from '@capacitor/app';


@Component({
  selector: 'tt-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  standalone: true
})

export class MapComponent implements OnInit, AfterViewInit {
  hostEl = inject(ElementRef<HTMLElement>);

  @ViewChild('ttMap', { static: true }) mapTarget: ElementRef<HTMLDivElement>;
  
  @Input() targetId: string;
  @Output() singleClick = new EventEmitter<[number, number]>();
  
  private map: Map;
  // private sizeObserver: ResizeObserver;
  private mapElement: HTMLElement;

  private ttLibConfig = inject<AppConfig>(TT_LIB_CONFIG);

  /** 
   * this will tell all components if the app is hidden or not (e.g. browser minimized or user opened other tab)
   * we could add this in the root app component but then you need to copy the code to every new app; the map component is normally always added
   * 
   * for native apps we activate the native 'appStateChange' listener, see property nativeAppVisibilityChangeListener
  */
  @HostListener('document:visibilitychange', [])
  onAppVisibilityChange() {
    if (!Capacitor.isNativePlatform()) {
      this.mapService.handleAppVisibilityChange(!document.hidden);
    }
  }
  //for window focus/blur event on native apps
  private nativeAppVisibilityChangeListener: PluginListenerHandle = null;

  constructor(
    private elementRef: ElementRef,
    private mapService: MapService,
    private viewService: ViewService,
    private layerService: LayerService,
    private controlService: ControlService,
    private permalinkService: PermalinkService,
    private appEventService: AppEventService,
    private translateService: TranslateService,
    private featureService: FeatureService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
  }

  async ngOnInit() {    
    // map creation
    this.map = this.mapService.getMap();
    // bind map with dom element  
    this.map.setTarget(this.mapTarget.nativeElement);
    // console.log(this.elementRef.nativeElement.childNodes[0]);
    
    //init view params from config or permalink

    //universal link
    this.appEventService.universalLink$
      .pipe(filter(params => !!params))
      .subscribe(params => {
        // console.log('*** universal link *** mapcomponent', params);
        // alert('*** map c init params')
        this.initParams(params);
        if (params['baselayer']) {
          let currentLayer: Layer = this.layerService.getBaseLayers().find((layer) => layer.id === params['baselayer']);
          this.layerService.showSelectedBaselayer(currentLayer);
        }
      })


    //Normal startup params
    if (!this.appEventService.universalLink$.value) {
      this.permalinkService.getParams().pipe(take(1)).subscribe(params => {
        // console.log('/// normal mapcomponent ', params);
        // alert('/// map c init params')
        this.initParams(params);
      })
    }

    /** end */


    // zoomAllExtent
    if (this.ttLibConfig.map.controls.zoomToExtent.zoomAllBtn) {
      this.controlService.setZoomAllExtent(this.ttLibConfig.map.controls.zoomToExtent.extent);
    }
    // scaleline
    if (this.ttLibConfig.map.controls.scaleLine) {
      this.controlService.addScaleLine('metric', 2);
    }

    //mousepostion
    // if (this.ttLibConfig.map.controls.mousePosition.addMousePosition) {
    //   this.controlService.initMouseProjections();
    // }

    //init layers after language set
    this.layerService.initLayerList(this.translateService.getCurrentLang()).pipe(take(1)).subscribe(() => {
      //init baselayers if not yet initialized
      // && this.layerService.getBaseLayers().length === 0
      if (this.ttLibConfig.map.baselayers) {
        this.layerService.initBaseLayers(this.ttLibConfig.map.baselayers.list, this.ttLibConfig.map.baselayers.voidLayer);
      }
      //init overlays
      this.layerService.initLayers();
      this.layerService.initMaskLayer();
    });
    /* eff nakijken...*/
    // In order to add predefined layers from ttLibConfig file
    const langParam: string = this.permalinkService.getLangParam();
    //initlist was called twice
    //! We need to exectute watchLayersParam when the list is available in the service
    // this.layerService.initLayerList(langParam != undefined ? langParam : 'en').subscribe(() => {
    //   if (this.ttLibConfig.map.predefinedLayers && this.ttLibConfig.map.predefinedLayers.length > 0) {
    //     this.ttLibConfig.map.predefinedLayers.forEach((layerId: string) => {
    //       this.layerService.findAvailableBusinessLayerById(layerId).subscribe((layer) => {
    //         this.layerService.addLayer(layer);
    //       });
    //     })
    //   }
    // });
    //todo add config condition?
    this.mapService.initMapClickOnMarker(this.mapService.getMap());
    //!resize observer test
    this.mapElement = document.querySelector('#map')
    this.mapService.initResizeObserver(this.mapElement);
    // // const map = new Map({
    // //   target: mapElement
    // // })
    // //? emit updatesize event?
    // this.sizeObserver = new ResizeObserver(entries => {
    //   const width = entries[0].contentRect.width;
    //   console.log(width);
    //   this.zone.run(() => {
    //     this.width$.next(entries[0].contentRect.width);
    //   });
    // });
    // // this.sizeObserver = new ResizeObserver(() => {
    // //   this.map.updateSize()
    // // })
    // this.sizeObserver.observe(this.mapElement);
    // //!
    // //sizeObserver.unobserve(myEl);


    //alternative listeners to pointerdown/pointerdown are touchstart/touchend & mousedown/mouseup
    //a rightclick or long tap triggers the default browser menu, we prevent it here and the show our own popup
    this.map.getTargetElement().addEventListener('contextmenu', (event) => { event.preventDefault(); this.mapService.handleContextMenu(event); return false; }, false);
    this.map.getTargetElement().addEventListener('pointerdown', (event) => { this.mapService.handleTapHoldStart(event, 'main'); }, { capture: true, passive: true });
    //passive false so that we can prevent the context menu when a map coordinate is found
    this.map.getTargetElement().addEventListener('pointerup', () => { this.mapService.handleTapHoldEnd(); }, { capture: true, passive: true });

    if (Capacitor.isNativePlatform()) {
      this.nativeAppVisibilityChangeListener = await App.addListener('appStateChange', (state: AppState) => {
        this.mapService.handleAppVisibilityChange(state.isActive);
      });
    }
  }

  ngOnDestroy() {
    // this.sizeObserver.unobserve(this.mapElement);
    this.map.getTargetElement().removeEventListener('contextmenu', (event) => { event.preventDefault(); this.mapService.handleContextMenu(event); return false; }, false);
    this.map.getTargetElement().removeEventListener('pointerdown', (event) => { this.mapService.handleTapHoldStart(event, 'main'); });
    this.map.getTargetElement().removeEventListener('pointerup', () => { this.mapService.handleTapHoldEnd(); });

    if (Capacitor.isNativePlatform() && this.nativeAppVisibilityChangeListener) {
      this.nativeAppVisibilityChangeListener.remove();
    }
  }

  ngAfterViewInit() {
    this.mapService.resize$.subscribe(() => {
      this.map.updateSize();
    })
    // update view parameters on moveend
    fromEvent(this.map, 'moveend')
      .pipe(debounceTime(500))
      .subscribe((event: any) => {
        let center = event.map.getView().getCenter();
        const x: string = format(center, "{x}", 2);
        const y: string = format(center, "{y}", 2);
        const zoomlevel: number = event.map.getView().getZoom();
        const zoom: string = zoomlevel.toString();
        this.permalinkService.updatePositionParams(x, y, zoom);
      });

    fromEvent(this.map, 'singleclick')
      .subscribe((event: any) => {
        const coord = event.coordinate;
        this.singleClick.emit(coord);
      });


    // this.mapService.getMap().on("moveend", (event) => {      
    //   let center = event.map.getView().getCenter();
    //   const x: string = format(center, "{x}", 2);
    //   const y: string = format(center, "{y}", 2);
    //   const zoomlevel: number = event.map.getView().getZoom();
    //   const zoom: string = zoomlevel.toString();
    //   this.permalinkService.updatePositionParams(x, y, zoom);
    //   // this.setPositionQueryParams(x, y, zoom);
    // });

    // preparing overlay for featureInfo
    this.featureService.addFeatureInfoTooltip(this.mapService.getMap());
    //todo unsubscribe
    this.mapService.setPointerCursorOnFeatureHover();
    this.mapService.setMapReady('main');
  }


  initParams(params) {
    if (this.ttLibConfig) {
      // TODO
      // let zoomLevel: number = this.map.getView().getZoom() != undefined ? this.map.getView().getZoom() : params["zoom"];
      // let x: number = this.map.getView().getCenter() != undefined ? this.map.getView().getCenter()[0] : params["x"];
      // let y: number = this.map.getView().getCenter() != undefined ? this.map.getView().getCenter()[1] : params["y"];
      // this.permalinkService.updatePositionParams(x.toString(), y.toString(), zoomLevel.toString());
      // this.viewService.initView(zoomLevel, [x, y]);
      let zoomLevel: number = this.ttLibConfig.map.view.zoomlevel;
      let center: Array<number> = this.ttLibConfig.map.view.center;
      let projectionCode: string = this.ttLibConfig.map.projection;
      let maxZoom: number = this.ttLibConfig.map.view?.maxZoom;
      let minZoom: number = this.ttLibConfig.map.view?.minZoom;
      let extent = (this.ttLibConfig.map.view.extent) ? this.ttLibConfig.map.view.extent : undefined;

      //this value used by the geolocation component at startup
      let wasStartUpWithPositionOrZoomRelatedParams = false;
      //this value is only for this method, to go to full extent after the checks below
      let goToFullExtentAfterChecks = true;

      //this.ttLibConfig.map.view.extent;
      //not very elegant but the only way for now -> TODO: find a better way
      if (params["zoom"] != undefined) {
        zoomLevel = Number(params["zoom"]);
        wasStartUpWithPositionOrZoomRelatedParams = true;
        goToFullExtentAfterChecks = false;
      } else {
        // no params
        if (this.map.getView().getZoom() !== undefined && zoomLevel !== this.map.getView().getZoom()) {
          // here we're retrieving the view of the current map (when route is changed)
          zoomLevel = this.map.getView().getZoom();
        }
      }
      if (params["x"] != undefined && params["y"] != undefined) {
        //! old links of previous version have comma in url, replace by point
        let x = params["x"].replace(/,/i, '.');
        let y = params["y"].replace(/,/i, '.');
        center = [x, y];
        wasStartUpWithPositionOrZoomRelatedParams = true;
        goToFullExtentAfterChecks = false;
      } else {
        if (this.map.getView().getCenter() && this.ttLibConfig.map.view.center[0] != this.map.getView().getCenter()[0] && this.ttLibConfig.map.view.center[1] != this.map.getView().getCenter()[1]) {
          center = this.map.getView().getCenter();
        }
      }
      //    this.permalinkService.updatePositionParams(center[0].toString(), center[1].toString(), zoomLevel.toString());
      center = [Number(center[0]), Number(center[1])];
      //Constrained Extent        
      this.viewService.initView(zoomLevel, center, projectionCode, extent, minZoom, maxZoom);


      //params "tracezoom" and "tracetab" are removed after startup
      //param "tracezoom" is always used in combination with param "trace"
      //param "trace" has priority over param "tracetab"
      if (typeof params["tracezoom"] === 'string' && params["tracezoom"] === 'true') {
        wasStartUpWithPositionOrZoomRelatedParams = true;
        goToFullExtentAfterChecks = false;
      } else if (typeof params["tracetab"] === 'string' && params["tracetab"] === 'suggestions_route') {
        wasStartUpWithPositionOrZoomRelatedParams = true;
      }

      this.mapService.wasStartUpWithPositionOrZoomRelatedParams = wasStartUpWithPositionOrZoomRelatedParams;

      //go to full extent
      if (goToFullExtentAfterChecks && this.ttLibConfig.map.controls.zoomToExtent.extent) {
        this.map.getView().fitInternal(polygonFromExtent(this.ttLibConfig.map.controls.zoomToExtent.extent));
      }
    }

  }

  setPositionQueryParams(x: string, y: string, z: string) {
    //console.log("called")
    this.router.navigate(['.'], {
      relativeTo: this.activatedRoute, queryParams: {
        x: x,
        y: y,
        z: z
      },
      queryParamsHandling: "merge"
    });
  }

  initLegends() {
    let languageParam: any;
    //this.permalinkService.getParams().subscribe((param) => languageParam = param["lang"]);
  }

  // resizeMap() {
  //another solution maybe resizeObserver:
  //https://openlayers.org/en/latest/doc/faq.html#why-is-zooming-or-clicking-in-the-map-off-inaccurate-
  //https://web.dev/resize-observer/
  //https://dev.to/christiankohler/how-to-use-resizeobserver-with-angular-9l5

  //setTimeout(function () { this.mapService.getMap().updateSize(); this.mapService.getMap().renderSync() }, 0);
  // }
}
